module.exports = __webpack_public_path__ + "media/Chateau del la riviere_1.a02e084e.mp4";